import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, switchMap } from 'rxjs';
import { TeamType, CreateTeamTypeDto, UpdateTeamTypeDto } from '@/models/team-type.model';
import { OidcSecurityService } from 'angular-auth-oidc-client';

@Injectable({
  providedIn: 'root',
})
export class TeamTypeService {
  private http = inject(HttpClient);
  private oidcSecurityService = inject(OidcSecurityService);
  private apiUrl = '/api/team-types';

  getTeamTypes(): Observable<TeamType[]> {
    return this.oidcSecurityService.getIdToken().pipe(
      switchMap((idToken) =>
        this.http.get<TeamType[]>(this.apiUrl, {
          headers: { Authorization: `Bearer ${idToken}` },
        })
      )
    );
  }

  getTeamTypeById(id: string): Observable<TeamType> {
    return this.oidcSecurityService.getIdToken().pipe(
      switchMap((idToken) =>
        this.http.get<TeamType>(`${this.apiUrl}/${id}`, {
          headers: { Authorization: `Bearer ${idToken}` },
        })
      )
    );
  }

  createTeamType(teamType: CreateTeamTypeDto): Observable<TeamType> {
    return this.oidcSecurityService.getIdToken().pipe(
      switchMap((idToken) =>
        this.http.post<TeamType>(this.apiUrl, teamType, {
          headers: { Authorization: `Bearer ${idToken}` },
        })
      )
    );
  }

  updateTeamType(id: number, teamType: UpdateTeamTypeDto): Observable<TeamType> {
    return this.oidcSecurityService.getIdToken().pipe(
      switchMap((idToken) =>
        this.http.put<TeamType>(`${this.apiUrl}/${id}`, teamType, {
          headers: { Authorization: `Bearer ${idToken}` },
        })
      )
    );
  }
}
